import api from "./api";
import {
  Movimentacao,
  UnifiedMovimentacaoCreate,
  UnifiedMovimentacaoPayload,
  MovimentacaoEmpreendimento,
  MovimentacaoUnidade
} from "../types/movimentacao";

export const movimentacaoService = {
  list: async (params?: { limit?: number; offset?: number }) => {
    const response = await api.get("/api/movimentacoes/", { params });
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/api/movimentacoes/${id}/`);
    return response.data;
  },

  delete: async (id: number) => {
    await api.delete(`/api/movimentacoes/${id}/`);
  },

  createUnifiedMovimentacao: async (data: UnifiedMovimentacaoCreate) => {
    const formData = new FormData();

    // Anexa um valor de movimentação sob a chave indexada esperada pelo backend
    // (ex.: movimentacoes_empreendimento[0][tabela_preco]). Arquivos precisam ir
    // como File de verdade — String(file) vira o texto inútil "[object File]".
    const appendMovimentacaoField = (
      prefixo: "movimentacoes_empreendimento" | "movimentacoes_unidade",
      index: number,
      key: string,
      value: unknown
    ) => {
      if (value === undefined || value === null) return;
      const campo = `${prefixo}[${index}][${key}]`;
      if (value instanceof File) {
        formData.append(campo, value, value.name);
      } else {
        formData.append(campo, String(value));
      }
    };

    // Append movimentacoes_empreendimento (inclui arquivos como tabela_preco,
    // book, arquivo_extra_1, arquivo_extra_2 quando presentes na própria
    // movimentação — cada upload vira sua própria linha, com data e vínculo
    // ao empreendimento).
    data.movimentacoes_empreendimento?.forEach((mov, index) => {
      Object.entries(mov).forEach(([key, value]) => {
        appendMovimentacaoField("movimentacoes_empreendimento", index, key, value);
      });
    });

    // Append movimentacoes_unidade
    data.movimentacoes_unidade?.forEach((mov, index) => {
      Object.entries(mov).forEach(([key, value]) => {
        appendMovimentacaoField("movimentacoes_unidade", index, key, value);
      });
    });

    // Append empreendimento files
    if (data.empreendimento_files) {
      data.empreendimento_files.forEach((file: File) => {
        formData.append(`empreendimento_files`, file);
      });
    }

    // Append unidade files
    if (data.unidade_files) {
      data.unidade_files.forEach((file: File) => {
        formData.append(`unidade_files`, file);
      });
    }

    const response = await api.post("/api/movimentacoes/unificada/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
};

export const movimentacaoEmpreendimentoService = {
  list: async (params?: { empreendimento?: number; data_hora_after?: string; data_hora_before?: string; limit?: number; offset?: number }) => {
    const response = await api.get("/api/movimentacoes/empreendimento/", { params });
    return response.data;
  },
  getById: async (id: number): Promise<MovimentacaoEmpreendimento> => {
    const response = await api.get(`/api/movimentacoes/empreendimento/${id}/`);
    return response.data;
  },
};

export const movimentacaoUnidadeService = {
  list: async (params?: { unidade?: number; data_hora_after?: string; data_hora_before?: string; limit?: number; offset?: number }) => {
    const response = await api.get("/api/movimentacoes/unidade/", { params });
    return response.data;
  },
  getById: async (id: number): Promise<MovimentacaoUnidade> => {
    const response = await api.get(`/api/movimentacoes/unidade/${id}/`);
    return response.data;
  },
};